import {QuoteWizardStateService} from '../quoteWizardState.service';
import {QuoteWizardNavigationService} from '../quoteWizardNavigation.service';
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import {IAuthenticationService} from '../../authentication/authentication.service';

export class WelcomeScreenController {
    public isReturningUser: boolean;

    public static $inject = ['quoteWizardNavigationService', 'quoteWizardStateService', '$state', 'screenLockService', 'authenticationService'];

    constructor(private navigationService: QuoteWizardNavigationService,
                private stateService: QuoteWizardStateService,
                public $state: ng.ui.IStateService,
                private screenLockService: ScreenLockService,
                public authenticationService: IAuthenticationService) {
        this.activate();
    }

    private activate(): void {

        this.screenLockService.broadcast(0);
        this.isReturningUser = this.authenticationService.isAuthenticated();
        this.stateService.viewModel.isUserOnWelcomePage = true;
        this.stateService.broadcastMenuNavigationEnabledChanged(false);
    }

    public startClick(): void {
        this.stateService.viewModel.isUserOnWelcomePage = false;
        this.stateService.broadcastMenuNavigationEnabledChanged(true);
        this.navigationService.goNext();

    }

    public returningSignInClick(): void {
        this.screenLockService.broadcast(1);
        this.stateService.broadcastMenuNavigationEnabledChanged(true);

        this.authenticationService.login();
    }

    public continueClick(): void {
        this.stateService.viewModel.isUserOnWelcomePage = false;
        this.stateService.broadcastMenuNavigationEnabledChanged(true);
        this.navigationService.restore(this.stateService.viewModel.clientStateContext.navigationContext.wizardSavedState);
    }
}